const contentActionTypes = {
  GET_FAQ_CONTENT_DATA: "get_faq_content_data",
  SAVE_FAQ_CONTENT_DATA: "save_faq_content_data",
  SET_ERROR_DATA: "faq_set_error_data"
};

export default contentActionTypes;
